<div class="container-fluid p-0">
    <!-- login page start-->
    <div class="authentication-main">
        <div class="row">
            <div class="col-md-12">
                <div class="auth-innerright">
                    <div class="authentication-box">
                        <div class="text-center"><img
                                src="assets/images/enplace_logo.png"
                                alt></div>
                        <div class="card mt-4">
                            <div class="card-body">
                                <div class="text-center">
                                    <h4>VERIFY EMAIL</h4>
                                    <h6 *ngIf="user">An email has been sent to
                                        <strong>{{user.email}}</strong>. Please
                                        follow the link on the message to
                                        verify your email address.</h6>
                                </div>
                                <form
                                    class="theme-form">
                                    <div class="form-group row mt-0 mb-0">
                                        <p class="mt-1 text-center">If you have
                                            already verified your email, you can
                                            refresh this page here.:</p>
                                        <button
                                            class="btn btn-success btn-block"
                                            (click)="reload()">Reload
                                            Page</button>
                                        <hr class="mt-4 mb-4" />
                                    </div>

                                    <div class="form-group row mb-0">
                                        <p class="text-center">If you
                                            haven't received
                                            the
                                            email yet,
                                            you can request a new verification
                                            email
                                            here:</p>
                                        <a href="javascript:void(0)"
                                            class="link-primary text-center"
                                            (click)="resendVerificationEmail()">Resend
                                            verification email</a>
                                        <div *ngIf="isLoading"
                                            class="d-flex justify-content-center">
                                            <div class="loader-box">
                                                <div class="loader">
                                                    <div
                                                        class="line bg-primary"></div>
                                                    <div
                                                        class="line bg-primary"></div>
                                                    <div
                                                        class="line bg-primary"></div>
                                                    <div
                                                        class="line bg-primary"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <p *ngIf="showResendMessage && user"
                                            class="mt-2 text-center text-success">A
                                            new
                                            verification email
                                            has been sent to {{user.email}}</p>
                                        <p *ngIf="showErrorMessage"
                                            class="mt-2 text-center text-danger">An
                                            error occurred while trying to
                                            resend the email. Please try again
                                            later.</p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- login page end-->
</div>
